var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealiable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "SHIELD",
    transform: "translate(23.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4147012,2.67493689 C26.4147012,2.67493689 17.9536843,11.122106 0.0445317424,11.6852506 L0.46758259,34.0702488 C0.608599539,46.0370718 7.80046395,56.8776055 18.799786,61.5235485 C21.0560572,62.3682654 23.5943623,63.3537685 26.5557182,63.9169131 C29.5170741,63.2129823 31.9143623,62.3682654 34.3116504,61.5235485 C45.1699555,56.8776055 52.3618199,46.0370718 52.6438538,34.0702488 L53.0669046,11.6852506 C34.8757182,10.9813199 26.4147012,2.67493689 26.4147012,2.67493689 Z",
    id: "Path",
    stroke: "#000000",
    fillOpacity: 0.8,
    fill: "#FFF3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26215886,49.8382979 C17.5306334,36.7451857 29.799108,23.5112874 41.7855487,10.136603 C31.3502945,7.46166607 26.4147012,2.67493689 26.4147012,2.67493689 C26.4147012,2.67493689 17.9536843,11.122106 0.0445317424,11.6852506 L0.46758259,34.0702488 C0.46758259,39.7016949 2.15978598,45.1923549 5.26215886,49.8382979 Z",
    id: "Path",
    fillOpacity: 0.5,
    fill: "#FF6F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8377521,6.05380454 C26.8377521,6.05380454 34.9575331,14.3601875 53.010719,15.0641183 L53.2237034,9.57345835 C35.0272382,8.86952759 26.8377521,0.563144609 26.8377521,0.563144609 C26.8377521,0.563144609 18.2409969,9.01031374 0.0445317424,9.57345835 L0.187810996,15.0641183 C18.2409969,14.3601875 26.8377521,6.05380454 26.8377521,6.05380454 Z",
    id: "Path",
    stroke: "#000000",
    fill: "#FF6F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4147012,62.93141 C26.4147012,62.93141 18.5177521,44.2068518 2.01876903,43.0805626 C4.69809106,51.1053732 10.7618199,58.0038947 18.799786,61.3827624 C21.0560572,62.2274793 23.5943623,63.2129823 26.5557182,63.7761269 C29.5170741,63.0721962 31.9143623,62.2274793 34.3116504,61.3827624 C42.3496165,58.0038947 48.4133453,51.1053732 51.0926673,43.0805626 C34.3116504,44.3476379 26.4147012,62.93141 26.4147012,62.93141 Z",
    id: "Path",
    stroke: "#000000",
    fill: "#FF6F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3123284,43.6437072 L13.4411419,34.6333934 C12.5950402,33.9294627 12.5950402,32.6623873 13.300125,31.9584565 C14.0052097,31.1137396 15.1333453,31.1137396 15.979447,31.8176704 L23.0302945,38.1530472 L38.4011419,20.5547782 C39.1062267,19.7100613 40.2343623,19.7100613 40.939447,20.4139921 C41.7855487,21.1179228 41.7855487,22.3849982 41.0804639,23.088929 L23.3123284,43.6437072 Z",
    id: "Path",
    stroke: "#000000",
    fill: "#FF6F61"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealiable);
export default __webpack_public_path__ + "static/media/realiable.61450b13ea68f69b5f573d68ba82da24.svg";
export { ForwardRef as ReactComponent };